"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyEmissionLog = void 0;
function makeEmptyEmissionLog() {
    return {
        statusId: -1,
        emissionRequestId: '',
        createdAt: '',
    };
}
exports.makeEmptyEmissionLog = makeEmptyEmissionLog;
//# sourceMappingURL=EmissionLog.js.map